import React from 'react' 

export const UploadImages = ({source, images,setImages}) =>{
    const [sources, setSources] = React.useState([]) //  const change = (e ) => setPercent(e.target.value)

    const handle = (e) => {
        if (!e.target.files || e.target.files.length === 0) return;

        let len = e.target.files.length;
        let file = e.target.files;

        for (let index = 0; index < len ; index++) {     
            let reader = new FileReader();
            if(file[index].type.match('image.*')){
                reader.readAsDataURL(file[index]);
            }
            reader.onloadend = () => {
                let src = { path: reader.result, file:file[index] };
                setSources((prev)=>[...prev,src])
            }
        }
    }
    


    return (
        <div>
            <div className="">
                <h4 className="cover_title">Media</h4>
                <label htmlFor="dropzone" className="mt-3 dropzone">
                    <svg height="40" fill="#333" viewBox="0 0 512 512">
                        <path d="M446.575,0H65.425C29.349,0,0,29.35,0,65.426v381.149C0,482.65,29.349,512,65.425,512h381.15
                                C482.651,512,512,482.65,512,446.574V65.426C512,29.35,482.651,0,446.575,0z M481.842,446.575
                                c0,19.447-15.821,35.267-35.267,35.267H65.425c-19.447,0-35.268-15.821-35.268-35.267v-55.007l99.255-84.451
                                c3.622-3.082,8.906-3.111,12.562-0.075l62.174,51.628c5.995,4.977,14.795,4.569,20.304-0.946L372.181,209.77
                                c2.67-2.675,5.783-2.935,7.408-2.852c1.62,0.083,4.695,0.661,7.078,3.596l95.176,117.19V446.575z M481.842,279.865l-71.766-88.366
                                c-7.117-8.764-17.666-14.122-28.942-14.701c-11.268-0.57-22.317,3.672-30.294,11.662L212.832,326.681l-51.59-42.839
                                c-14.959-12.422-36.563-12.293-51.373,0.308l-79.712,67.822V65.426c0-19.447,15.821-35.268,35.268-35.268h381.15
                                c19.447,0,35.267,15.821,35.267,35.268V279.865z" />
                        <path
                            d="M161.174,62.995c-40.095,0-72.713,32.62-72.713,72.713c0,40.094,32.619,72.713,72.713,72.713s72.713-32.619,72.713-72.713
                                S201.269,62.995,161.174,62.995z M161.174,178.264c-23.466,0-42.556-19.091-42.556-42.556c0-23.466,19.09-42.556,42.556-42.556
                                c23.466,0,42.556,19.091,42.556,42.556S184.64,178.264,161.174,178.264z" />
                    </svg>
                    <p>Click or drag&drop for upload images</p>
                    <p>PNG, JPG, GIF formats and max 10MB</p>
                </label>
                <input  
                    id="dropzone" 
                    type="file" name="images" 
                    className="hidden" 
                    multiple
                    onChange={handle}
                />
            </div>
    
            <div className="upload-images">
            <ul>
                {sources?.length > 0 && sources.map((image,i)=> <Preview key={'src-'+i} image={image} sources={sources} setSources={setSources} images={images} setImages={setImages} />  )}
            </ul>
          
        </div>
    
    </div>
    )
} 
 